<template>
  <div>
    <div class="container">
      <div class="header-title " v-if="isPaySuccess" >
        {{ infoList.campaignSurveyName }}
      </div>
      <div :class="isPaySuccess ? 'main-style' : 'main' ">
         <div class="main-item" :class="item.show ? 'main-item-border' : '' "  v-for="(item,listIndex) in list" :key="listIndex">
           <div class="main-issue "  v-if="item.show" >
             <div class="main-issue-title main-issue-border">
               <span class="topicIcon" v-if="isShowTitleNumber">{{ listIndex >= 9 ? '' : '0' }}{{ listIndex + 1 }}</span>
               <p>{{ item.category }} <span style="color: #006ab5">{{ item.subTitle || '' }}</span></p>
             </div>
             <div v-for="(questions, qIndex) in item.questionItems" :key="qIndex">
               <div v-if="questions.type===4" style="padding-left:24px ">
                 <div class="main-options" v-if="item.show">
                   <div class="main-options-item" :class="option.selectClass"
                        @click="switchIndex(listIndex,option,qIndex)"
                        v-for="(option,index) in questions.indexList" :key="index"
                   >{{ option.text }}
                     <div class="tips" v-if="option.text === item.questionItems[0].value">
                       {{ item.questionItems[0].value }}分
                     </div>
                   </div>
                 </div>
                 <div class="main-issue-prompt">
                   <p>{{questions.badSatisfaction}}</p>
                   <p>{{questions.goodSatisfaction }}</p>
                 </div>
               </div>

               <div v-if="item.show">
                 <div class="main-topic ">
                   <div class="main-questionName" v-if="questions.questionName">
                    <span class="main-questionName-icon" v-if="questions.icon">
                      <img :src="imgUrl+'icons/'+questions.icon" alt="">
                    </span>
                     <p class="main-questionName" :style="questions.type!==3 ? 'color:#006ab5' :''">
                       {{ questions.questionName }}
                       <span v-if="questions.type === 3" style="color: #006ab5">{{ questions.subTitle }}</span>
                     </p>
                   </div>
                   <div class="topic-item" v-if="questions.type === 2" :class="$route.query.type ==='USER_CENTER' ? '' : 'main-topicMain' ">
                     <div class="main-topicItem"
                          v-for="(option,oIdx) in questions.optionItems"
                          :key="option.optionId" @click="onClickOption(listIndex,option.optionId,oIdx,qIndex)">
                       <span :class="option.checked ? 'main-topicItem-icon-active' : 'main-topicItem-icon'"></span>
                       <div class="main-topicItemText" v-if="!option.isOther">{{
                           option.optionName
                         }}{{ option.other }}
                       </div>
                       <div class="main-topicItemText other" v-else>
                         <div>
                           <span style="color:#000000">其他 </span>(请注明：
                         </div>
                         <div>
                           <input type="text" class="other-input" @click.stop="inputTextOther(listIndex,oIdx,qIndex)"
                                  v-model="option.otherVal">
                         </div>
                         )
                       </div>
                     </div>
                   </div>
                   <div  class="topic-item"  v-if="questions.type === 1" :class="$route.query.type ==='USER_CENTER' ? '' : 'main-topicMain' ">
                     <div class="main-topicItem"
                          v-for="(option,oIdx) in questions.optionItems"
                          :key="oIdx" @click="radioChange(listIndex,option.optionId,qIndex,option)">
                       <span :class="option.checked ? 'main-topicItem-icon-active' : 'main-topicItem-icon'"></span>
                       <div class="main-topicItemText">{{ option.optionName }}</div>
                     </div>
                   </div>
                   <!--输入框-->
                   <div class="main-teatarea" v-if="questions.type === 3">
                     <div class="main-inputText" v-if="isShowTextInput">{{ inputText }}</div>
                     <input type="text" v-model="inputText" @focus="onFocusInput" @blur="onBlurInput">
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
        <div class="footer" v-if="isShowSubmit&&submitStyle">
          <div class="interiorSubmit" @click="submit">提交</div>
        </div>
      </div>

      <div class="footer" v-if="isShowSubmit&&!submitStyle">
        <div class="submit" @click="submit">提交</div>
      </div>
    </div>
    <div class="popups-model" v-if="isShowPopup">
      <div class="popups">
        <div class="popups-img">
          <div class="img-info">
            <span>
              <img :src="isSuccess ? imgUrl+'icons/'+'success.svg':imgUrl+'icons/'+'required.svg' " alt="">
            </span>
          </div>
        </div>
        <div class="popups-submit">
          <div class="popups-prompt" v-if="isSuccess">
            <p>提交成功</p>
            <p style="margin-bottom: 5px">感谢您的反馈</p>
            <div @click="onJumpHome">{{btnText}}</div>
          </div>
          <div class="popups-prompt" v-else-if="!isSuccess">
            <p style="margin:10px 0;">请您完成问题后提交</p>
            <div @click="onClosePopups">我知道了</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import api from "@/api";
import router from "@/router";

export default {
  name: "Questionnaire",
  props: {
    infoList: {
      type: Object
    },
    isShowTitleNumber: {
      type: Boolean
    },
    isPaySuccess: {
      type: Boolean,
      default: false
    },
    submitStyle: {
      type: Boolean
    },
    bookingRdId:{
      type: String,
      default:''
    },
    orderId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: null,
      imgUrl: `${process.env.VUE_APP_IMG_URL}/wechatMiniProgram/questionnaire/`,
      indexList: [],
      inputText: '',
      isShowTextInput: false,
      isShowPopup: false,
      isSuccess: false,
      isShowTopic: false,
      isShowSubmit: false,
      otherVal: '',
      btnText:'',
      successLink:''
    }
  },

  mounted() {
    this.list = this.infoList.categoryQuestionItems
    let query = this.$route.query;
    if (query.type === "USER_CENTER") {
      this.isShowSubmit = true
    }
  },
  methods: {
    // 评分
    switchIndex(listIdx, item, idx) {
      console.log(item, idx, listIdx)
      let {indexList, customType} = this.list[listIdx].questionItems[idx]
      console.log(this.list[listIdx])
      indexList.forEach((r) => {
        r.selectClass = r.text <= item.text ? `bg${r.text}` : "";
        this.list[listIdx].questionItems[idx].indexList = indexList
        this.list[listIdx].questionItems[idx].value = item.text
      })

      if (customType === "Point" || listIdx === 0) {
        console.log(123)
        this.list && this.list.forEach((r, idx) => {
          if( this.$route.query.type !== 'USER_CENTER'){
            if (idx > 0) r.show = item.text <= 8;
            this.isShowTopic = item.text <= 8;
            this.isShowSubmit = true
          }
        });
      }

    },
    onClickOption(listIdx, id, idx,qIndex) {
      console.log(listIdx, id, idx)
      let questions = this.list[listIdx].questionItems[qIndex];
      let currOptions = questions.optionItems;
      console.log(questions)
      let count = currOptions.filter(item => item.checked).length;
      currOptions && currOptions.forEach((r) => {
        if (questions.optionLimit === count && questions.optionLimit > 0) {
          if (r.optionId === id && r.checked) {
            r.checked = false;
          }
        } else {
          if (r.optionId === id) {
            r.checked = !r.checked;
          }
        }
        this.list[listIdx].questionItems[qIndex].optionItems = currOptions
      })
    },
    radioChange(listIdx, id, qIndex, opt) {
      console.log(listIdx, id, qIndex, opt)
      let currOptions = this.list[listIdx].questionItems[qIndex].optionItems;
      console.log(currOptions)
      currOptions && currOptions.forEach((r) => {
        r.checked = r.optionId === id;
      })
      this.list[listIdx].questionItems[qIndex].optionItems = currOptions
      console.log(this.list[listIdx])
    },
    inputTextOther(listIdx, oIdx, qIndex) {
      console.log(listIdx, oIdx, qIndex)
      // list[${lIdx}].questionItems[${idx}].optionItems[${oIdx}].otherVal =  e.detail.value
      // this.list[listIdx].questionItems[qIndex].optionItems[oIdx].otherVal = option.otherVal
      // console.log(this.list[listIdx].questionItems[qIndex].optionItems[oIdx].otherVal)
      // console.log(this.list[listIdx].questionItems[qIndex].optionItems[oIdx]) =
    },
    // 提交
    async submit() {
      let verify = [];
      let firstVerify = false;
      let firstQuestion = this.list[0].questionItems[0];
      if (firstQuestion.customType === "Point") {
        if (firstQuestion.value > 8) {
          firstVerify = true;
        }
      }
      if (!firstVerify) {
        this.list && this.list.forEach((r) => {
          r.questionItems && r.questionItems.forEach((question) => {
            let {isRequired, optionItems} = question;
            if (isRequired) {
              if (optionItems.length > 1) {
                let count = optionItems.filter(item => item.checked);
                if(question.isOther) {
                  let countOther = count.filter(item => item.isOther && item.otherVal === '');
                  if(countOther.length > 0) {
                    verify.push(r.NO)
                  } else {
                    if(count.length === 0) verify.push(r.NO);
                  }
                } else {
                  if(count.length === 0) verify.push(r.NO);
                }
              } else {
                if (question.value === null || question.value === '') verify.push(r.NO)
              }
            }
          })
        })
      }
      verify = [...new Set(verify)];
      console.log(verify)
      console.log(this.list)

      if (verify.length > 0) {
        this.isShowPopup = true
        this.isSuccess = false
        return;
      }

      let submitList = [];
      if (firstVerify && firstQuestion.value > 8) {
        submitList.push({
          QuestionId: firstQuestion.questionId,
          Score: firstQuestion.value
        })
      } else {
        this.list && this.list.forEach((r) => {
          r.questionItems && r.questionItems.forEach((question) => {
            let currQ = null;
            let {isRequired, optionItems, questionId, type} = question;
            console.log(isRequired, question)
            if (type === 3) {
              console.log(3)
              if (this.inputText) {
                currQ = {
                  questionId: questionId,
                  FillContent: this.inputText
                }
              }
            } else if (type === 4) {
              console.log(4)
              if (question.value) {
                currQ = {
                  QuestionId: questionId,
                  Score: question.value
                }
              }
            } else {
              console.log(5)
              currQ = {
                QuestionId: questionId,
                OptionItems: []
              }
              optionItems && optionItems.forEach((option) => {
                let {isOther, otherVal, optionId, checked} = option;
                if (checked) {
                  if (isOther) {
                    currQ.OptionItems.push({
                      OptionId: optionId,
                      Supplement: otherVal
                    })
                  } else {
                    currQ.OptionItems.push({
                      OptionId: optionId
                    })
                  }
                }
              })
            }
            console.log(currQ)
            submitList.push(currQ);
          })
        })
      }
      console.log(submitList)

      let from = {
        // username:store.state.user.userToken || "",
        OrderId: this.orderId || '',
        //需要改为加密的encBookingRecordId
        encBookingRecordId:  this.bookingRdId || '',
        CampaignSurveyId: this.infoList.campaignSurveyId,
        CampaignAnswerItems: submitList.filter(r => r)
      }

      let {success, data, errMsg} = await api.questionnaire.submitCampaignAnswer({
        ...from
      })
      if (success) {
        console.log(data, errMsg)
        this.btnText = data.buttonText || '我知道了'
        this.successLink = data.pcLink || ''
        this.isShowPopup = true
        this.isSuccess = true
      } else {
        this.isSuccess = false
      }

    },
    // 问卷提交后点击我知道了跳转到首页
    onJumpHome() {
      if(this.successLink){
        window.location.href = this.successLink
      }else{
        router.replace({path: "/"})
      }
    },
    onClosePopups() {
      this.isShowPopup = false
    },
    // 获取焦点和失去焦点进行的操作
    onFocusInput() {
      this.isShowTextInput = true
    },
    onBlurInput() {
      this.isShowTextInput = false

    }

  },


}
</script>
<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}

.container {
  position: relative;
  width: 1200px;
  //height: 727px;
  background-color: #FFFFFF;
  //overflow: auto;
  //padding: 0 30px;
  margin: 0 auto;
}

.header-title {
  width: 1200px;
  position: absolute;
  top: 0;
  z-index: 99;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  font-weight: 600;
  background: url("https://resource.rcclchina.com.cn/questionnaire/headerBg.jpg") no-repeat 100% 100%;
  line-height: 50px;
}

.topicIcon {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #FCC202;
  line-height: 18px;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  border-radius: 50%;
}
.main-style{
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  padding: 60px 150px 0;
}
.main {
  box-sizing: border-box;
  //width: 347px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  padding: 0 150px;
  .main-header-title {
    width: 85%;
    margin: 0 auto;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #808080;
    line-height: 17px;
    padding: 11px 0 5px 0;
  }

  .main-issue {
    //width: 304px;
    margin: 0 auto;
    .main-issue-title {
      display: flex;
      //width: 322px;
      margin: 0 auto;
      align-items: center;
      padding-top: 11px;
      //border-top: 1px solid #333;

      p {
        padding: 0;
        font-size: 14px;
        font-weight: 550;
        color: #000000;
        line-height: 20px;
        margin: 0 0 0 6px;
      }
    }

    .main-options {
      display: flex;
      margin: 22px 15px 8px 0;
      font-size: 14px;

      .main-options-item {
        width: 50px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        position: relative;
        cursor: pointer;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-right: none;
        &:first-child {
          border-radius: 3px 0 0 3px;
        }
        &:last-child {
          border-radius: 0 3px 3px 0;
          border-right: 1px solid #ebebeb;
        }
        .tips {
          width: 50px;
          height: 26px;
          position: absolute;
          top: -26px;
          font-size: 8px;
          line-height: 18px;
          left: 50%;
          margin-left: -25px;
          color: #006ab5;
          background: url("https://resource.rcclchina.com.cn/wechatMiniProgram/questionnaire/icons/scoreBg.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .main-issue-prompt {
      width: 500px;
      //margin: 0 auto;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      line-height: 17px;
      color: #5B5B5B;
      box-sizing: border-box;
      //padding-bottom: 15px;
    }
  }
 .main-item-border +.main-item-border {
    border-top: 0.3px dashed rgba(226, 226, 226, 1);
  }
  .main-topic {
    padding: 5px 24px;

    .main-teatarea {
      height: 29px;
      margin-top: 8px;
      position: relative;

      .main-inputText {
        width: 100%;
        height: 85px;
        background-color: #f6f6f6;
        border-radius: 4px;
        position: absolute;
        top: -90px;
        word-wrap: break-word;
        word-break: break-all;
        overflow: auto;
        font-size: 12px;
        font-weight: 400;
        color: #606060;
        line-height: 17px;
        border: 1px solid rgba(207, 207, 207, 1);
        padding: 8px 8px 0 8px;
      }

      input {
        width: 100%;
        height: 100%;
        border: 1px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        padding: 0 4px;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
        font-style: normal;
      }
    }
  }

  .main-questionName-icon {
    display: inline-block;
    width: 13px;
    height: 13px;
    //background-color: #FCC202;
    line-height: 13px;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    border-radius: 50%;
  }

  .main-questionName {
    height: 19px;
    font-size: 13px;
    font-weight: 600;
    color: #000000;
    line-height: 18px;
    display: flex;
    gap: 6px;
    align-items: center;
  }
.topic-item{
  display: flex;
  gap: 0 20px;
  flex-wrap: wrap;
  padding: 5px 0;
}
  .main-topicMain {
    border-bottom: 0.3px dashed rgba(226, 226, 226, 1);
  }

  .main-topicItem {
    min-width: 23%;
    height: 19px;
    font-size: 12px;
    font-weight: 400;
    color: #000000;
    line-height: 17px;
    display: flex;
    align-items: center;
    margin: 4px 0;
    cursor: pointer;
    //flex:1 auto;


    .main-topicItem-icon {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      border: 1px solid rgba(183, 183, 183, 1);
    }

    .main-topicItem-icon-active {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      //background-color: #2183f4;
      border: 4px solid #006ab5;
    }

    .main-topicItemText {
      margin-left: 6px;
    }

    .other {
      display: flex;
      align-items: center;
      color: rgba(151, 151, 151, 1);

      .other-input {
        border: none;
        width: 100px;
        font-size: 12px;
        height: 20px;
        border-bottom: 1px solid #999999;
        color: rgba(151, 151, 151, 1);
        font-style: normal;
      }
    }
  }
}


.main-options-item.bg1 {
  background: #F0F6FF;
}

.main-options-item.bg2 {
  background: #E4EEFF;
}

.main-options-item.bg3 {
  background: #D0E1FF;
}

.main-options-item.bg4 {
  background: #BBD4FF;
}

.main-options-item.bg5 {
  background: #9DC1FE;
}

.main-options-item.bg6 {
  background: #78A9FF;
}

.main-options-item.bg7 {
  background: #699FFC;
}

.main-options-item.bg8 {
  background: #5893F9;
}

.main-options-item.bg9 {
  background: #4786F2;
}

.main-options-item.bg10 {
  background: #3077F2;
}

.footer {
  padding: 20px 0 30px 0;

  .submit {
    width: 370px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: linear-gradient(225deg, #FFDB17 0%, #FCBF00 100%);
    //box-shadow: 0 1px 5px 0 rgba(199, 151, 74, 0.62);
    border-radius: 4px;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
    margin: 0 auto;
    cursor: pointer;
  }

  .interiorSubmit {
    width: 270px;
    height: 29px;
    text-align: center;
    background: linear-gradient(225deg, #FFDB17 0%, #FCBF00 100%);
    box-shadow: 0 1px 5px 0 rgba(199, 151, 74, 0.62);
    border-radius: 16px;
    font-size: 14px;
    font-weight: 600;
    color: #000000;
    line-height: 29px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.popups-model {
  position: fixed;
  top: 0;
  width: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.60);
  z-index: 99;

  .popups {
    width: 268px;
    height: 268px;
    border-radius: 8px;
    position: fixed;
    top: 25%;
    left: 50%;
    margin-left: -134px;
    overflow: hidden;

    .popups-img {
      width: 100%;
      height: 151px;
      background: url("https://resource.rcclchina.com.cn/wechatMiniProgram/questionnaire/popupBg.svg") no-repeat 100% 100%;
      padding: 43px 0;

      .img-info {
        width: 65px;
        height: 65px;
        background: linear-gradient(225deg, #ACE941 0%, #5CB139 100%);
        border-radius: 50%;
        margin: 0 auto;
        padding: 17px 0;

        span {
          display: block;
          width: 30px;
          height: 30px;
          margin: 0 auto;
        }
      }
    }

    .popups-submit {
      width: 100%;
      height: 117px;
      background-color: #FFFFFF;
      padding: 11px 0;

      .popups-prompt {
        width: 85%;
        margin: 0 auto;
        cursor: pointer;

        p {
          font-size: 18px;
          font-weight: 600;
          color: #4A4A4A;
          line-height: 25px;
          text-align: center;
        }

        div {
          text-align: center;
          width: 130px;
          height: 32px;
          background: linear-gradient(225deg, #FFDB17 0%, #FCBF00 100%);
          box-shadow: 0px 1px 5px 0px rgba(199, 151, 74, 0.62);
          border-radius: 16px;
          font-weight: 600;
          color: #000000;
          line-height: 32px;
          font-size: 14px;
          margin: 0 auto;
        }
      }
    }
  }
}

img {
  width: 100%;
  height: 100%;
}

.separate {
  //border-top: #999999 1px solid;
  padding-top: 11px;
  border-bottom: 0.3px dashed rgba(226, 226, 226, 1);
}
.headerBox {
  background: linear-gradient(326deg, #FFFFFF 0%, #2493F4 99%);
  padding: 10px;
  color: #ffffff
}
.headerBox .title {
  font-size: 20px;
}
</style>
